import { Component } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { PushNotificationService, FirebaseAnalyticsService, UnifiedLoginService } from '@monorepo/services';
import { LOCAL_STORAGE_UTILS } from '@monorepo/utils';
import { TranslateService } from '@ngx-translate/core';
import { CapacitorHttpService } from '@monorepo/services';
import { environment } from '../environments/environment';
import { TMMFirebaseAnalyticsEvent } from '@monorepo/types';

@Component({
  selector: 'monorepo-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private pushNotificationService: PushNotificationService,
    private translate: TranslateService,
    private capacitorHttpService: CapacitorHttpService,
    private firebaseAnalyticsService: FirebaseAnalyticsService<TMMFirebaseAnalyticsEvent>,
    private unifiedLoginService: UnifiedLoginService,
  ) {
    this.platform.ready().then(async () => {
      await SplashScreen.hide();
      console.log('[Push-Test] AppComponent Platform Ready');

      this.pushNotificationService.registerDevice().then(() => {
        console.log('[Push-Test] AppComponent pushNotificationService register success');
        return true;
      });

      if (environment.production && Capacitor.getPlatform() !== 'web') {
        try {
          await this.firebaseAnalyticsService.init(
            true,
            {
              apiKey: 'AIzaSyB4NwIF-1ycugCeANNs3L-AEvSH_8Y0SQs',
              authDomain: 'machine-maintenance-dev.firebaseapp.com',
              projectId: 'machine-maintenance-dev',
              storageBucket: 'machine-maintenance-dev.firebasestorage.app',
              messagingSenderId: '979221265325',
              appId: '1:979221265325:web:b824dc3459c43dc2e6ff24',
              measurementId: 'G-0V9RLC21Y8',
            },
            this.unifiedLoginService.getUsername(),
          );
        } catch (error) {
          console.error('[Firebase Analytics] Initialization error:', error);
        }
      } else {
        console.log('(firebase-analytics) Firebase Analytics is disabled in dev mode.');
      }
    });

    this.initializeLocale();
  }

  async initializeLocale() {
    const locale = LOCAL_STORAGE_UTILS.retrieveData('locale');
    if (locale) {
      this.translate.setDefaultLang(locale);
      const cookieVal = await this.capacitorHttpService.getCookie('locale');
      if (locale !== cookieVal) {
        this.capacitorHttpService.setCookie({ key: 'locale', value: locale });
      }
    } else {
      this.translate.setDefaultLang('en');
      LOCAL_STORAGE_UTILS.storeData('locale', 'en');
      this.capacitorHttpService.setCookie({ key: 'locale', value: 'en' });
    }
  }
}
